import PanelBox from '../../components/PanelBox';
import ActionMenu from '../../components/ActionMenu';
import JobsMenu, {DataFlowItem, DeleteJobComponent} from './actionStaffMenu';
import JobStatusComponent from './statusComponent';
import React, { Component } from 'react';
import { connect } from "react-redux";
import { Select, Modal, Table, Input, Icon, Row, Col, Radio, Dropdown, DatePicker, Button} from 'antd';
import { API_SEND_COMMENT } from '../../config';
import { switch_api } from '../../actions/switch_api';
import { assign, getTechs, getTreatmentPlansData, getTechJobs2, getTechJobs3, deleteJob, getLinksTech, getLinksTech2, nextStep, fallback, changePrintReadyParams } from '../../actions/jobs';
import moment from 'moment';
import { public_path, tech_api, client_api, type as app_type } from "../../api.json";


// import ct from '../../assets/svgicons/DeepCBCT_analysis.svg';
import plan_roots_add from '../../assets/svgicons/3d-plan_Roots_add.svg';
// import plan_roots from '../../assets/svgicons/3d-plan_roots.svg';
// import plan_deepct from '../../assets/svgicons/3d-plan_DeepCBCT.svg';

import plan_standard from '../../assets/svgicons/plan_main.svg';
import plan_roots from '../../assets/svgicons/plan_roots.svg';
import plan_deepct from '../../assets/svgicons/plan_deepct.svg';

const { RangePicker } = DatePicker;
const { Option } = Select;

const dateFormat = 'YYYY-MM-DD';

const dateFormatList = ['YYYY-MM-DD'];

const actions = {
  plan_standart: [
    {
      icon: plan_roots_add,
      link: (uuid) => `/case/upload/plan-roots/${ uuid }`,
      title: '3D-Plan Roots'
    }
  ],
};

const case_status = {
  "S_DICOM_DOWNLOAD" : "Downloading DICOMs",
  "S_DICOM_CONVERT" : "Converting DICOMs",
  "S_DATA_CHECK" : "Check incoming data",
  "S_NN_SEGMENT" : "Automatic segentation",
  "S_TEETH_SEPARATION" : "Teeth separation",
  "S_AUTO_3D_TEETH_LABELING" : "Auto teeth labeling",
  "S_BUILD_MODELS" : "3D models building",
  "S_TRANSFER_ALIGN" : "Alignment transfer",
  "S_PUBLISH_RESULT" : "Results publishing",
  "S_DATA_DOWNLOAD" : "Data downloading",
  "S_XLS_PARSE" : "XLS parsing",
  "S_DATA_UPDATE" : "Update plan data",
  "S_CENTROID_COMPUTE" : "IPR computing",
  "S_OCCLUSION_COMPUTE" : "Occlusogram computing",
  "S_PUBLISH" : "Publishing",
  "S_ASSETS_CREATE" : "Assets creating",
  "S_PDF_RENDER" : "PDF rendering",
  "S_QUALITY_CONTROL" : "Quality control",
  "S_ALIGN_MANUAL": "Manual alignment",
  "S_TEETH_ROI_QUALITY_CONTROL": "Check Teeth ROI",
  "S_TEETH_ROI": "Compute Teeth ROI",
  "S_OCCLUSAL_PLANE_SETUP": "Occlusal plane setup",
  "S_OCCLUSAL_PLANE": "Occlusal plane orientation",
  "S_TRIM_BASE": "Model base trim setup",
  "S_OCCLUSAL_PLANE_AND_TRIM_BASE_SETUP": "Occlusal plane and base setup",
  "S_ORIENT_AND_PREPROCESS_SCAN": "Occlusal plane orientation and model base creation",
  "S_GENERATE_BASE": "Model base creation",
  "S_TEETH_MARKUP": "Teeth markup",
  "S_CROWN_SEGMENTATION": "Crown segmentation",
  "S_CROWN_SEGMENTATION_V2": "Crown segmentation V2",
  "S_SEGMENTED_ASSET_CREATION": "Segmented asset creation",
  "S_LOCAL_C_S": "Crown local coordinates setup",
  "S_SETUP_QA": "Setup control",
  "S_MODELLING": "Movement Modelling",
  "S_CLINICIAN_REVIEW" : "Clinician review",
  "S_PRINT_READY_DONE": "Print ready done",
  "S_DOWNLOAD_V1_PLAN": "Download v1 plan",
  "S_FULL_PLAN_QUALITY_CONTROL": "Full plan quality control",
  "S_FULL_PLAN_CLINICIAN_REVIEW": "Full plan clinician review",
  "S_SETUP_FAKE_MANAGEMENT": "Add fake crown",
  "TEST_TEETH_SEGMENTATION_WITHOUT_ROI": "Test Teeth segmentation without ROI",
  "TEST_GENERATE_UPPER_AND_LOWER_STL": "Test Generate Upper And Lower stl",
  "CT_DATA_QA": "CT Segmentation QA",
  "DS_TREATMENT_INITIAL_SYNC":"Treatment initial syncronization",
  "DS_ESTIMATE_TREATMENT_QUALITY":"Estimating treatment quality",
  "DS_TREATMENT_FINAL_SYNC":"Treatment final syncronization",
  "DS_TREATMENT_PLAN_FINAL_SYNC":"Treatment plan final syncronization",
  "DS_ROOTS_SEGMENT_ORIG_NIFTI": "CT Segmentation",
  "DS_ROOTS_SPLIT_TEETH": "Teeth splitting",
  "DS_ROOTS_DOWNLOAD_SEGMENTATIONS": "Downloading segmentations",
  0: "Draft",
  1: "Link for upload generated",
  '-20': "Failed"
}

const tableTypes = {
  ct: 'DeepCT analysis',
  ct_align: 'DeepCBCT analysis v1.1 (align)',
  ct_v2: 'DeepCT analysis v2',
  ct_v2_auto: 'DeepCT analysis v2 auto',
  plan_standart: 'Crowns plan',
  plan_roots: 'Roots plan',
  plan_deep_ct: 'DeepCT plan',
  plan_standard_orthostudio: 'Crowns plan Orthostudio',
  plan_standard_3shape_1c: 'Crowns plan 3Shape',
  plan_standard_3shape_color: 'Crowns plan 3Shape Color',
  plan_standard_archform_1c: 'Crowns plan Archform',
  plan_standard_onyxceph: 'Crowns plan OnyxCeph',
  plan_standard_orthostudio_v5: 'Crowns plan Orthostudio v5',
  plan_standard_suresmile_sou: 'Crowns plan SureSmile',
  teeth_alignment_modelling: 'Teeth alignment modelling',
  teeth_alignment_modelling2: 'Ace Aligners modelling',
  teeth_alignment_modelling_external: 'Teeth alignment modelling External',
  roots_alignment_modelling: 'Roots alignment modelling',
  roots_alignment_modelling_external: 'Roots alignment modelling External',
  ram_single_control_point: 'RAM Single Control Point'
};

const download_links = {
  'print_ready_archive' : 'Print ready archive',
  'sources_archive' : 'Plan v1 archive'
}

const date_options = {
  year: "numeric",
  month: "long",
  day: "numeric",
  hour: "numeric",
  minute: "numeric",
  hour12: false,
}

const JON_WAITING_JOBS = [0, 1, -20];
const JOB_STATUS_WAITING = "waiting";
const JOB_STATUS_ALL = "all";
const FLOW_STEP_TYPE_MANUAL = 0;

function isWaitingJob(status) {
  return JON_WAITING_JOBS.indexOf(status) > -1 ? true : false;
}

let updateJobs = () => 0;

const mapStateToProps = (state) => {
  let jobs = state.jobs || [];
  return {
    jobs: jobs,
    links: state.links,
    isSupervisor: state.user.is_supervisor,
    // username: state.user.username,
    waitingJobs: jobs.filter(job => isWaitingJob(job.status))
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getTechJobs2: (date_from, date_to) => dispatch(getTechJobs2(date_from, date_to)),
    getTechJobs3: (date_from, date_to) => dispatch(getTechJobs3(date_from, date_to)),
    // getTechs: (uuid) => dispatch(getTechs(uuid)),
    getLinks: (uuid) => dispatch(getLinksTech(uuid)),
    getLinks2: (uuid) => dispatch(getLinksTech2(uuid)),
    nextStep: (uuid) => dispatch(nextStep(uuid)),
    fallback: (uuid) => dispatch(fallback(uuid)),
    eraseJobs: () => dispatch({type: 'ERASE_JOBS'}),
    deleteJob: (uuid) => dispatch(deleteJob(uuid)),
    changePrintReadyParams: (uuid, distance) => dispatch(changePrintReadyParams(uuid, distance))
  }
}


class CaseTableStaff extends Component {
  constructor(props) {
    super(props);
    this.state = {
      downloadLinksAvailable: false,
      downloadLinks: null,
      downloadModal: false,
      preciseLinksModal: false,
      shareModal: false,
      assignModal: false,
      QAModal: false,
      QALinks: {},
      preciseLinks: [],
      showModal: false,
      nextStepButton: false,
      uuid: null,
      sorted_jobs: [],
      searchValue: '',
      tableLoading: false,
      filterWaitingJobs: false,
      sortedInfo: {
        order: 'descend',
        columnKey: 'last_modified',
      },
    };
    this.nextStep = this.nextStep.bind(this)
    this.fallback = this.fallback.bind(this)
    this.gumDistanceInput = React.createRef()
  }


  shouldShowWaitingRadioButton() {
    return this.props.waitingJobs.length > 0
  }

  componentDidMount() {
    updateJobs = () => {
      if (this.props.isSupervisor) {
        this.props.getTechJobs2(moment().subtract(30, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD'))
      } else {
        this.props.getTechJobs3(moment().subtract(30, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD'))
      }
      this.setState({'tableLoading': true})
    };

    updateJobs();
  }

  componentWillReceiveProps(nextProps) {
    nextProps.jobs && this.setState({tableLoading: false})
    this.state.downloadModal && nextProps.links && this.setState({downloadLinks: nextProps.links, downloadLinksAvailable: true, downloadModal: false});
  }

  componentWillUnmount() {
    this.props.eraseJobs()
  }

  requestJobs(date_from, date_to) {
    updateJobs = () => {
      if (this.props.isSupervisor) {
        this.props.getTechJobs2(date_from, date_to)
      } else {
        this.props.getTechJobs3(date_from, date_to)
      }
      this.setState({'tableLoading': true})
    };

    updateJobs();
  }

  isManualStep(data) {
    return data.flow_step_queue && data.flow_step_queue.step.step_type == FLOW_STEP_TYPE_MANUAL;
  }

  shouldShowDeleteButton(data) {
    return isWaitingJob(data.status) || data.flow_step_queue && data.flow_step_queue.step.step_type == FLOW_STEP_TYPE_MANUAL;
  }

  filterByWaitingJobs(jobs) {
    let hasWaitingJobs = this.props.waitingJobs.length > 0;
    if (hasWaitingJobs) {
      if (this.state.filterWaitingJobs) {
        jobs = jobs.filter(job => isWaitingJob(job.status) === true);
      } else {
        jobs = jobs.filter(job => isWaitingJob(job.status) === false);
      }
    }
    return jobs;
  }

  // filterJobs(searchText) {
  //   let filtred_data = []
  //   let table_data = this.props.jobs;
  //   if (searchText !== '') {
  //     table_data.map((record) => {
  //       let match = false
  //       Object.values(record).map((value) => {
  //         if (value && Object.values(value).length) {
  //           Object.values(value).map((subvalue)=>{
  //             if (subvalue && subvalue.toString().toUpperCase().indexOf(searchText.toUpperCase()) != -1) {
  //               match = true
  //             }
  //           })
  //         } else if (value && value.toString().toUpperCase().indexOf(searchText.toUpperCase()) != -1) {
  //           match = true
  //         }
  //       })
  //       match ? filtred_data.push(record) : null
  //     })
  //   } else {
  //     filtred_data = this.props.jobs;
  //   }
  //   return this.filterByWaitingJobs(filtred_data);
  // }

  filterJobs(searchText) {
    let filtred_data = []
    let table_data = this.props.jobs;

    if (searchText !== '') {
      table_data.map((record) => {
        let match = false

        if (record.ct_scan && record.ct_scan.patient_tag) {
          if (record.ct_scan.patient_tag.toString().toLowerCase().indexOf(searchText.toLowerCase()) > -1) {
            match = true
          } else {
            match = false
          }
        }

        if (match === false && record.uuid) {
          if (record.uuid.toString().toLowerCase().indexOf(searchText.toLowerCase()) > -1) {
            match = true
          } else {
            match = false
          }
        }

        match ? filtred_data.push(record) : null
      })
    } else {
      filtred_data = this.props.jobs;
    }

    return this.filterByWaitingJobs(filtred_data);
  }

  onSearchHandler(searchText) {
    this.setState({'searchValue':searchText});
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter,
    });
  }

  handleCaseTableRadioSwitch = e => {
    const { value } = e.target;
    this.setState({'filterWaitingJobs':value === JOB_STATUS_WAITING});
  };

  nextStep(uuid) {
    this.props.nextStep(uuid)
  }

  fallback(uuid) {
    this.props.fallback(uuid)
  }

  rework(uuid) {
    let token = localStorage.getItem('token');
    return fetch(switch_api(API_SEND_COMMENT(uuid)), {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Authorization': `Token ${token}`,
        'Content-Type': 'application/json; charset=utf-8'
      },
      credentials: 'include',
      body: ''
    })
    .then((response) => {
      if (!response.ok) {
        console.error(`Failed loading { API_SEND_COMMENT }: ${response.statusText}`);
      } else {
        this.setState({ downloadLinksAvailable: false }, () => updateJobs());
      }
    })
    .catch((e) => {
      console.warn(e);
    })
  }

  render() {
    let { sortedInfo } = this.state;
    sortedInfo = sortedInfo || {};

    const source = this.filterJobs(this.state.searchValue);

    const columns = [{
      title: 'id',
      dataIndex: 'uuid',
      render: (id) => id.slice(0,8),
      key: 'id',
      sorter: (a, b) => a.uuid - b.uuid,
      sortOrder: sortedInfo.columnKey === 'id' && sortedInfo.order,
    }, {
      title: 'Owner',
      dataIndex: 'member',
      key: 'member',
      render: (member) => {
        let res = '';
        if (member) {
          if (member.username) {
            res = member.username;
          } else if (member.first_name && member.last_name) {
            res = `${ member.first_name } ${ member.last_name }`;
          }
        }
        return res;
      },
      // sorter: (a, b) => a.ct_scan.patient_tag - b.ct_scan.patient_tag,
      // sortOrder: sortedInfo.columnKey === 'patient_tag' && sortedInfo.order,
    }, {
      title: 'Patient tag',
      dataIndex: 'ct_scan.patient_tag',
      key: 'patient_tag',
      sorter: (a, b) => a.ct_scan.patient_tag - b.ct_scan.patient_tag,
      sortOrder: sortedInfo.columnKey === 'patient_tag' && sortedInfo.order,
    }, {
      title: 'Patient notes',
      dataIndex: 'patient_note',
      key: 'patient_notes',
      render: (patient_notes) => <div style={{maxWidth: '100px'}}> {patient_notes} </div>
    }, {
      title: 'Status',
      key: 'status',
      render: (data) => {
        let status = "";
        if (data.flow_step_queue && data.flow_step_queue.step) {
          status = case_status[data.flow_step_queue.step.note];
        }
        if (!status) {
          status = case_status[data.status];
        }
        return <div><JobStatusComponent data={data} isManualStep={this.isManualStep(data)}/>  {status}</div>
      },
      sorter: (a, b) => a.status - b.status,
      sortOrder: sortedInfo.columnKey === 'status' && sortedInfo.order,
    }, {
      title: 'Updated',
      dataIndex: 'last_modified',
      render: (date) => moment(date).format('DD-MM-YYYY HH:mm:ss'),
      key: 'last_modified',
      sorter: (a, b) => Date.parse(a.last_modified) - Date.parse(b.last_modified),
      sortOrder: sortedInfo.columnKey === 'last_modified' && sortedInfo.order,
    }, {
      title: 'Created',
      dataIndex: 'created',
      render: (date) => moment(date).format('DD-MM-YYYY HH:mm:ss'),
      key: 'created',
      sorter: (a, b) => Date.parse(a.created) - Date.parse(b.created),
      sortOrder: sortedInfo.columnKey === 'created' && sortedInfo.order,
    }, {
      title: 'Flow',
      dataIndex: 'flow.type',
      render: (type) => tableTypes[type],
      key: 'flow',
    },
    {
      title: 'Plan type',
      dataIndex: 't_plan.plan_type.name',
      render: (plan_type) => plan_type,
      key: 'plan_type',
    },
    {
      title: 'Links',
      render: (data) => {
       return <Button
        type='default'
        onClick={
          async (evt) => {
            evt.stopPropagation();
            const preciseLinks = await getTreatmentPlansData(data.uuid);
            if (Array.isArray(preciseLinks))
            {
              this.setState({
                preciseLinksModal: true,
                preciseLinks,
              });
            }
          }}>
            <Icon
              type='bars'
              title='3D Precise links'
            />
        </Button>
      },
      key: 'links',
    },
    {
      title: 'Actions',
      render: (data) => {
        if (this.props.isSupervisor === true && this.shouldShowDeleteButton(data)) {
          const menuOverlay =
            <JobsMenu
              data={data}
              actions={actions}
              onJobDelete={this.props.deleteJob}
              showModal={() => {
                this.setState({
                  assignModal: true,
                  job_uuid: data.uuid,
                  job_assigned_groups: data.designated_to
                }, () => {
                  getTechs(data.uuid)
                    .then((technicians) => {
                      const groups = {};
                      const defaults = {};

                      technicians.map((technician, i) => {
                        technician.groups.forEach((technician_group) => {
                          if (!groups[technician_group.name]) {
                            groups[technician_group.name] = { __ID__: technician_group.id };

                            const assigned = data.designated_to.filter((group) => group.group.id === technician_group.id);

                            if (assigned.length && assigned[0] && !this.state[`${ data.uuid }-${ technician_group.id }`]) {
                              defaults[`${ data.uuid }-${ technician_group.id }`] = assigned[0].member.id;
                            }
                          }

                          if (!groups[technician_group.name][technician.username]) {
                            groups[technician_group.name][technician.username] = technician.id;
                          }
                        });
                    });

                    this.setState({ groups, ...defaults });
                  });
                });
              }}
            />;

          return <ActionMenu overlay={menuOverlay} ignoreOnClick={true} iconType={"down"}/>;
        } else {
          return <DataFlowItem data={data} actions={actions} />;
        }
      },
      key: 'actions',
    },
  ];


    return (
      <div>
        <PanelBox title={"Case table"}>
          <Row style={{ marginBottom: 16 }}>
            <Col span={8} align="left">
              {this.shouldShowWaitingRadioButton() &&
                <Radio.Group defaultValue={JOB_STATUS_ALL} onChange={this.handleCaseTableRadioSwitch}>
                  <Radio.Button value={JOB_STATUS_ALL}>Active</Radio.Button>
                  <Radio.Button value={JOB_STATUS_WAITING}>Pending</Radio.Button>
                </Radio.Group>
              }
            </Col>
            <Col span={8} offset={8} align="right">
              <RangePicker
                placeholder={['Start date', 'End date']}
                style={{ width: 220, marginBottom: 10, textAlign: 'left' }}
                defaultValue={[moment().subtract(30, 'days'), moment()]}
                format={dateFormat}
                onChange={(evt) => {
                  let from = moment().subtract(30, 'days').format('YYYY-MM-DD');
                  let to = moment().format('YYYY-MM-DD');

                  if (evt[0] && evt[0]._d) {
                    from = moment(evt[0]._d).format('YYYY-MM-DD');
                  }

                  if (evt[1] && evt[1]._d) {
                    to = moment(evt[1]._d).format('YYYY-MM-DD');
                  }

                  this.requestJobs(from, to);
                }}
              />
              <br />
              <Input
                  prefix={<Icon type="search" />}
                  placeholder="Search"
                  style={{ width: 220 }}
                  onChange={(e) => this.onSearchHandler(e.target.value)}
              />
            </Col>
          </Row>
          <Table
            dataSource={source}
            id="case-table"
            columns={columns}
            rowKey="uuid"
            loading={this.state.tableLoading}
            onChange={this.handleChange}
            onRowClick={(item) => {
              const { note } = item.flow_step_queue.step;
              const isExternalFlow = item.flow.type.includes('external');

              if(isExternalFlow)
              {
                if (item.flow.type === 'roots_alignment_modelling_external') {
                  if (
                    note === 'S_DATA_CHECK' ||
                    note === 'S_TEETH_ROI_QUALITY_CONTROL' ||
                    note === 'S_BUILD_MODELS' ||
                    note === 'S_ALIGN_MANUAL'
                  ) {
                    window.location = `/ctscan/?uuid=${item.uuid}&remote=${localStorage.getItem('API').replace('api/v1','')}`.replace(/\/$/g, '');
                  } else if (note === 'S_PRINT_READY_DONE') {
                    this.setState({downloadModal: true, nextStepButton: false, uuid: item.uuid}, () => this.props.getLinks(item.uuid));
                  } else if (
                    note === 'S_FULL_PLAN_QUALITY_CONTROL' ||
                    note === 'S_FULL_PLAN_CLINICIAN_REVIEW'
                  ) {
                    // window.location = `/case/control2/${item.flow.type.replace(/\_/g, '-')}/${item.uuid}`;

                    this.setState({
                      QAModal: true,
                      QALinks: {
                        standard: `/case/control/plan-standart/${item.uuid}?flow=roots_alignment_modelling`,
                        roots: `/case/control/plan-roots/${item.uuid}?flow=roots_alignment_modelling`,
                        deepct: `/case/control/plan-deep-ct/${item.uuid}?flow=roots_alignment_modelling`,
                      },
                    });
                  } else {
                    window.open(`${ window.location.origin }/teeth-alignment-modelling/?uuid=${item.uuid}`, '_blank');
                  }
                }
                else {
                  if (note === 'S_DATA_UPDATE') {
                    window.location = `/case/plan-update-form/${item.uuid}`;
                  } else if (
                    note === 'S_QUALITY_CONTROL' ||
                    note === 'S_CLINICIAN_REVIEW'
                  ) {
                    window.location = `/case/control/${item.flow.type.replace(/_external/g, '').replace(/\_/g, '-')}/${item.uuid}`;
                  } else if (note === 'S_PUBLISH' && app_type === 'standalone') {
                    this.setState({
                      shareModal: true,
                      uuid: item.uuid,
                    });
                  } else if (
                    note === 'S_OCCLUSAL_PLANE_SETUP' ||
                    note === 'S_OCCLUSAL_PLANE' ||
                    note === 'S_TRIM_BASE' ||
                    note === 'S_GENERATE_BASE' ||
                    note === 'S_OCCLUSAL_PLANE_AND_TRIM_BASE_SETUP' ||
                    note === 'S_ORIENT_AND_PREPROCESS_SCAN' ||
                    note === 'S_TEETH_MARKUP' ||
                    note === 'S_CROWN_SEGMENTATION' ||
                    note === 'S_CROWN_SEGMENTATION_V2' ||
                    note === 'S_SEGMENTED_ASSET_CREATION' ||
                    note === 'S_LOCAL_C_S' ||
                    note === 'S_SETUP_QA' ||
                    note === 'S_MODELLING' ||
                    note === 'DS_TREATMENT_INITIAL_SYNC' ||
                    note === 'DS_ESTIMATE_TREATMENT_QUALITY' ||
                    note === 'DS_TREATMENT_FINAL_SYNC' ||
                    note === 'DS_TREATMENT_PLAN_FINAL_SYNC' ||
                    note === 'S_SETUP_FAKE_MANAGEMENT'
                  ) {
                    window.open(`${ window.location.origin }/teeth-alignment-modelling/?uuid=${item.uuid}`, '_blank');
                  } else if (note === 'S_PRINT_READY_DONE') {
                    this.setState({downloadModal: true, nextStepButton: false, uuid: item.uuid}, () => this.props.getLinks(item.uuid));
                  } else if (note === 'S_DOWNLOAD_V1_PLAN') {
                    this.setState({downloadModal: true, nextStepButton: true, uuid: item.uuid}, () => this.props.getLinks2(item.uuid));
                  } else {
                    window.location = `/ctscan/?uuid=${item.uuid}&remote=${localStorage.getItem('API').replace('api/v1','')}`.replace(/\/$/g, '');
                  }
                }
              }
              else {
                if (item.flow.type === 'roots_alignment_modelling') {
                  if (
                    note === 'S_DATA_CHECK' ||
                    note === 'S_TEETH_ROI_QUALITY_CONTROL' ||
                    note === 'S_BUILD_MODELS' ||
                    note === 'S_ALIGN_MANUAL'
                  ) {
                    window.location = `/ctscan/?uuid=${item.uuid}&remote=${localStorage.getItem('API').replace('api/v1','')}`.replace(/\/$/g, '');
                  } else if (note === 'S_PRINT_READY_DONE') {
                    this.setState({downloadModal: true, nextStepButton: false, uuid: item.uuid}, () => this.props.getLinks(item.uuid));
                  } else if (
                    note === 'S_FULL_PLAN_QUALITY_CONTROL' ||
                    note === 'S_FULL_PLAN_CLINICIAN_REVIEW'
                  ) {
                    // window.location = `/case/control2/${item.flow.type.replace(/\_/g, '-')}/${item.uuid}`;

                    this.setState({
                      QAModal: true,
                      QALinks: {
                        standard: `/case/control/plan-standart/${item.uuid}?flow=roots_alignment_modelling`,
                        roots: `/case/control/plan-roots/${item.uuid}?flow=roots_alignment_modelling`,
                        deepct: `/case/control/plan-deep-ct/${item.uuid}?flow=roots_alignment_modelling`,
                      },
                    });
                  } else {
                    window.open(`${ window.location.origin }/teeth-alignment-modelling/?uuid=${item.uuid}`, '_blank');
                  }
                }
                else if (item.flow.type === 'ram_single_control_point') {
                  if (note === 'CT_DATA_QA') {
                    window.open(`${ window.location.origin }/teeth-alignment-modelling/?uuid=${item.uuid}`, '_blank');
                  }
                  else {
                    window.location = `/ctscan/?uuid=${item.uuid}&remote=${localStorage.getItem('API').replace('api/v1','')}`.replace(/\/$/g, '');
                  }
                }
                else {
                  if (note === 'S_DATA_UPDATE') {
                    window.location = `/case/plan-update-form/${item.uuid}`;
                  } else if (
                    note === 'S_QUALITY_CONTROL' ||
                    note === 'S_CLINICIAN_REVIEW'
                  ) {
                    window.location = `/case/control/${item.flow.type.replace(/\_/g, '-')}/${item.uuid}`;
                  } else if (note === 'S_PUBLISH' && app_type === 'standalone') {
                    this.setState({
                      shareModal: true,
                      uuid: item.uuid,
                    });
                  } else if (
                    note === 'S_OCCLUSAL_PLANE_SETUP' ||
                    note === 'S_OCCLUSAL_PLANE' ||
                    note === 'S_TRIM_BASE' ||
                    note === 'S_GENERATE_BASE' ||
                    note === 'S_OCCLUSAL_PLANE_AND_TRIM_BASE_SETUP' ||
                    note === 'S_ORIENT_AND_PREPROCESS_SCAN' ||
                    note === 'S_TEETH_MARKUP' ||
                    note === 'S_CROWN_SEGMENTATION' ||
                    note === 'S_CROWN_SEGMENTATION_V2' ||
                    note === 'S_SEGMENTED_ASSET_CREATION' ||
                    note === 'S_LOCAL_C_S' ||
                    note === 'S_SETUP_QA' ||
                    note === 'S_MODELLING' ||
                    note === 'DS_TREATMENT_INITIAL_SYNC' ||
                    note === 'DS_ESTIMATE_TREATMENT_QUALITY' ||
                    note === 'DS_TREATMENT_FINAL_SYNC' ||
                    note === 'DS_TREATMENT_PLAN_FINAL_SYNC' ||
                    note === 'S_SETUP_FAKE_MANAGEMENT'
                  ) {
                    window.open(`${ window.location.origin }/teeth-alignment-modelling/?uuid=${item.uuid}`, '_blank');
                  } else if (note === 'S_PRINT_READY_DONE') {
                    this.setState({downloadModal: true, nextStepButton: false, uuid: item.uuid}, () => this.props.getLinks(item.uuid));
                  } else if (note === 'S_DOWNLOAD_V1_PLAN') {
                    this.setState({downloadModal: true, nextStepButton: true, uuid: item.uuid}, () => this.props.getLinks2(item.uuid));
                  } else {
                    window.location = `/ctscan/?uuid=${item.uuid}&remote=${localStorage.getItem('API').replace('api/v1','')}`.replace(/\/$/g, '');
                  }
                }
              }
            }}
          />
        </PanelBox>

        <Modal
          title="Download links"
          centered
          visible={this.state.downloadLinksAvailable}
          // onOk={() => this.setState({ downloadLinksAvailable: false })}
          onCancel={() => this.setState({ downloadLinksAvailable: false })}
          cancelButtonProps={{
            style: {
              display: 'none',
            }
          }}
          footer={[
            this.state.nextStepButton ? <Button key="fallback" type="secondary" onClick={() => this.rework(this.state.uuid)}>Fallback to modelling</Button> : null,
            this.state.nextStepButton ?

              <Button
                key="next_step"
                type="secondary"
                onClick={async () => {
                  await this.props.changePrintReadyParams(this.state.uuid, this.gumDistanceInput.current.input.value);
                  // this.gumDistanceInput.current.input.value = 2;
                  await this.props.nextStep(this.state.uuid);
                  this.setState({ downloadLinksAvailable: false });
                }}
              >
                  Next step
              </Button> :

              <Button
                style={{ float: 'left' }}
                key="fallback"
                type="primary"
                onClick={async () => {
                  await this.props.fallback(this.state.uuid);
                  this.setState({ downloadLinksAvailable: false });
                }}
              >
                Fallback
              </Button>,

            <Button key="ok" type="primary" onClick={() => this.setState({ downloadLinksAvailable: false })}>OK</Button>,
          ]}
        >
          {
            this.state.downloadLinks && Object.keys(this.state.downloadLinks).length ?
              <div style={{marginTop:8}}>
                {Object.keys(this.state.downloadLinks).map((item,key)=>(
                  <p key={key}><a href={this.state.downloadLinks[item]}>{download_links[item]}</a></p>)
                )}
                {
                  this.state.nextStepButton ?
                    <div>
                      <span>Set gum distance</span>
                      <Input
                        ref={this.gumDistanceInput}
                        style={{ width: 'auto', marginLeft: 10 }}
                        type="number"
                        step="0.1"
                        min="0"
                        defaultValue="2.0"
                        onChange={(evt) => evt.target.value = Math.abs(evt.target.value)}
                        placeholder="Set gum distance"
                      />
                    </div> :
                    null
                }
              </div>
              :
              <div style={{marginTop:8}}>
                <p>No files available</p>
              </div>
          }
        </Modal>

        <Modal
          title="Share links"
          centered
          visible={this.state.shareModal}
          onOk={() => this.setState({ shareModal: false })}
          onCancel={() => this.setState({ shareModal: false })}
          cancelButtonProps={{
            style: {
              display: 'none',
            }
          }}
        >
          <p style={{ margin: 0 }}>
            { 'Tech: ' }
            <a target='_blank' href={ `${ tech_api }/${ public_path }?uuid=${ this.state.uuid }` }>{ `${ tech_api }/${ public_path }?uuid=${ this.state.uuid }` }</a>
          </p>
          <p style={{ margin: '10px 0 0 0' }}>
            { 'Client: ' }
            <a target='_blank' href={ `${ client_api }/${ public_path }?uuid=${ this.state.uuid }` }>{ `${ client_api }/${ public_path }?uuid=${ this.state.uuid }` }</a>
          </p>
        </Modal>

        <Modal
          title="Assign"
          centered
          visible={this.state.assignModal}
          onOk={() => this.setState({ assignModal: false })}
          onCancel={() => this.setState({ assignModal: false })}
          cancelButtonProps={{
            style: {
              display: 'none',
            }
          }}
        >
          {
            this.state.groups && Object.keys(this.state.groups).map((group) => (
              <div key={group}>
                <div>{group}</div>

                <Select
                  style={{marginBottom: 10, width: '100%'}}
                  value={this.state[`${ this.state.job_uuid }-${ this.state.groups[group].__ID__ }`]}
                  onChange={(user_uuid) => {
                    this.setState({ [`${ this.state.job_uuid }-${ this.state.groups[group].__ID__ }`]: user_uuid });

                    assign(this.state.job_uuid, user_uuid, this.state.groups[group].__ID__);
                  }}
                >
                  {
                    Object.keys(this.state.groups[group]).map((user, i) => (
                      user === '__ID__' ?
                        null :
                        <Option value={this.state.groups[group][user]} key={user}>{user}</Option>
                    ))
                  }
                </Select>
              </div>
            ))
          }
        </Modal>

        <Modal
          title="Roots ailgnment modelling QA"
          centered
          visible={this.state.QAModal}
          onOk={() => this.setState({ QAModal: false })}
          onCancel={() => this.setState({ QAModal: false })}
          cancelButtonProps={{
            style: {
              display: 'none',
            }
          }}
        >
          <p style={{ margin: 0, display: 'inline-block', width: '33%', textAlign: 'center' }}>
            <a target='_blank' href={ this.state.QALinks.standard }>
              <img style={{ width: 100 }} src={plan_standard} />
              <div>Standard</div>
            </a>
          </p>
          <p style={{ margin: '10px 0 0 0', display: 'inline-block', width: '33%', textAlign: 'center' }}>
            <a target='_blank' href={ this.state.QALinks.roots }>
              <img style={{ width: 100 }} src={plan_roots} />
              <div>Roots</div>
            </a>
          </p>
          <p style={{ margin: '10px 0 0 0', display: 'inline-block', width: '33%', textAlign: 'center' }}>
            <a target='_blank' href={ this.state.QALinks.deepct }>
              <img style={{ width: 100 }} src={plan_deepct} />
              <div>Deep CT</div>
            </a>
          </p>
        </Modal>

        <Modal
          title="3D Precise links"
          centered
          visible={this.state.preciseLinksModal}
          onOk={() => this.setState({ preciseLinksModal: false })}
          onCancel={() => this.setState({ preciseLinksModal: false })}
          cancelButtonProps={{
            style: {
              display: 'none',
            }
          }}
        >
          {
          this.state.preciseLinks.length &&
          (
            <div>
              <div style={{ marginBottom: '8px', overflow: 'hidden'}}>
                {'Patient tag: '}
                <b> {`${this.state.preciseLinks[0].patient_tag}`} </b>
              </div>

              <div
                style={{
                  display: 'grid',
                  overflowY: 'scroll',
                  marginLeft: '16px',
                }}
              >
                {
                  this.state.preciseLinks.map(
                    (plan_info, index) =>
                    {
                      return (
                        <div style={{display: 'grid', marginBottom: '8px', borderBottom: '1px solid #e8e8e8', gap: '4px' }}>
                          <div> {`Version ${plan_info.version}`}</div>
                          <div> {`Created: ${ (new Date(plan_info.created).toLocaleString('en-US', date_options)) }`}</div>
                          { plan_info.approved && <div> <b> {`Approved: ${ new Date(plan_info.approve_date).toLocaleString('en-US', date_options) }`} </b> </div> }
                          <div> {`Total modifications: ${plan_info.total_modifications}`}</div>
                          <div style={{display: 'flex', justifyContent: 'flex-end'}}>
                            <Button
                              type='default'
                              style={{
                                margin: '5px 10px',
                                overflow: 'hidden',
                                cursor: 'pointer',
                              }}
                              onClick={(evt) => {
                                evt.preventDefault();
                                navigator.clipboard.writeText(plan_info.precise_link)
                                const currentTarget = evt.currentTarget;

                                const handleEvent = () =>
                                {
                                  currentTarget && currentTarget.classList.remove('-accepted');
                                  window.removeEventListener('mousedown', handleEvent)
                                }

                                currentTarget.classList.add('-accepted');
                                window.addEventListener('mousedown', handleEvent);
                              }}
                            >
                              Copy
                            </Button>
                            <Button
                              type='link'
                              href={plan_info.precise_link}
                              style={{
                                margin: '5px 10px',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                cursor: 'pointer',
                              }}
                            >
                              Open
                            </Button>
                          </div>
                        </div>
                      )
                    }
                  )
                }
              </div>
            </div>
            )
          }
        </Modal>
      </div>
    );
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(CaseTableStaff)


// WEBPACK FOOTER //
// ./src/views/Cases/caseTableStaff.jsx